import { marginBottom, marginTop, typography } from "../../../../common/styles";
import { List } from "../../../../common/components";
import React from "react";
import { Service } from "../../../../AppDataProvider/types";
import ServiceList from "../ServiceList/ServiceList";
import sortServicesByCategory from "../sortServicesByCategory/sortServicesByCategory";
import styled from "styled-components";
export type ServicesByCategoryListProps = {
  services: Service[];
};
const CategoryName = styled.h2`
  ${typography.title};
  color: ${({
  theme
}) => theme.colours.primaryText};
  ${marginTop.zero}
  ${marginBottom.l}
`;
const ListItem = styled.li`
  &:not(:first-child) {
    ${marginTop.l}
  }
`;
export function ServicesByCategoryList(props: ServicesByCategoryListProps) {
  const {
    services
  } = props;
  const servicesByCategory = sortServicesByCategory(services);
  return <List data-sentry-element="List" data-sentry-component="ServicesByCategoryList" data-sentry-source-file="ServicesByCategoryList.tsx">
      {servicesByCategory.map(category => <ListItem key={category.categoryId}>
          <CategoryName>{category.categoryName}</CategoryName>
          <ServiceList services={category.services} />
        </ListItem>)}
    </List>;
}
export default ServicesByCategoryList;